// src/App.tsx
import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from "./Routes.tsx";
import React from "react";

function App() {
  React.useLayoutEffect(() => {
    if (window.location.hostname === "facebook.earthboundmartian.com") {
      window.location.replace("https://facebook.com/earthboundmartian");
    }
    if (window.location.hostname === "instagram.earthboundmartian.com") {
      window.location.replace("https://instagram.com/earthboundmart1");
    }
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
